import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ReportActivityPage from "../components/ReportActivityPage";

const ReportActivity = () => {
  return (
    <div>
      <MasterLayout>
        <ReportActivityPage />
      </MasterLayout>
    </div>
  );
};

export default ReportActivity;
